<template>
  <v-card class="rounded-xl customer-recovery" :border="false" :elevation="0">
    <v-col cols="12" class="d-flex justify-space-between">
      <p class="title">{{ $t('CUSTOMER_RECOVERY.TITLE') }}</p>
      <div class="d-flex reminder">
        <p class="mr-2">{{ itemNumber }}</p>
        <p>{{ $t('CUSTOMER_RECOVERY.REMINDER') }}</p>
      </div>
    </v-col>
    <v-infinite-scroll
      height="400"
      :items="repairFileList"
      :onLoad="load"
      @scroll="onScroll"
      empty-text=""
      class="d-flex flex-column ga-2"
    >
      <template v-for="(repairFile, index) in repairFileList" :key="repairFile">
        <v-row
          no-gutters
          class="customer-recovery-row"
          :class="{
            'customer-recovery-row': true,
            'last-item': index === repairFileList.length - 1
          }"
          @click="redirectToRepairFileDetail(repairFile.boomerang_id)"
        >
          <v-col cols="4" class="d-flex" :id="'company-tooltip-' + index">
            <v-tooltip
              color="#E5E5E5"
              v-if="isTextOverflowed(index)"
              :text="repairFile.company_name"
              location="start"
            >
              <template v-slot:activator="{ props }">
                <p class="company" v-bind="props">
                  {{ repairFile.company_name }}
                </p>
              </template>
            </v-tooltip>
            <p v-else class="company">{{ repairFile.company_name }}</p>
          </v-col>
          <v-col cols="8">
            <div class="d-flex justify-center status-content mb-1">
              <p class="status-macro">
                {{ $t('COMMON.STATUS_DETAIL.' + repairFile.status_detail) }}
              </p>
            </div>
            <div class="d-flex justify-center">
              <p class="date">
                {{ $t('CUSTOMER_RECOVERY.LAST_FOLLOW_UP') }}
                {{ getFormattedDate(repairFile.last_relaunch_date) }}
              </p>
            </div>
          </v-col>
        </v-row>
      </template>
    </v-infinite-scroll>
  </v-card>
</template>

<script>
import repairFileService from '@/services/RepairFileService'
import { handleResponseError } from '@/components/utils/globalFunction'

export default {
  name: 'CustomerRecover',
  data() {
    return {
      loading: false,
      loadingMore: false,
      itemNumber: 0,
      page: 1,
      pages: null,
      limit: 8,
      repairFileList: []
    }
  },
  created() {
    this.getCustomerRecoveryList()
  },
  methods: {
    async getCustomerRecoveryList() {
      this.loading = true
      try {
        this.page = 1
        const response = await repairFileService.getPaginatedRepairFileCustomerRecoveryList(
          this.page,
          this.limit
        )
        this.repairFileList = response.data
        this.pages = response.max_page
        this.itemNumber = response.item_number
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    load({ done }) {
      if (this.page === this.pages) {
        done('empty')
        return
      }
      setTimeout(async () => {
        done(await this.loadMore())
      }, 250)
    },
    async loadMore() {
      if (this.page < this.pages) {
        await this.loadMoreRepairFileCustomerRecoveryList()
        return 'ok'
      } else {
        return 'empty'
      }
    },
    async loadMoreRepairFileCustomerRecoveryList() {
      this.loadingMore = true
      try {
        this.page++
        const response = await repairFileService.getPaginatedRepairFileCustomerRecoveryList(
          this.page,
          this.limit
        )
        this.repairFileList.push(...response.data)
        this.pages = response.max_page
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loadingMore = false
      }
    },
    async onScroll(event) {
      const scrollContainer = event.target
      const scrollHeight = scrollContainer.scrollHeight
      const clientHeight = scrollContainer.clientHeight
      if (!this.loadingMore && scrollContainer.scrollTop + clientHeight >= 0.8 * scrollHeight) {
        this.loadingMore = true
        await this.loadMore()
        this.loadingMore = false
      }
    },
    isTextOverflowed(index) {
      const vColElement = document.getElementById(`company-tooltip-${index}`)
      if (vColElement) {
        const pElement = vColElement.querySelector('.company')
        if (vColElement && pElement) {
          return pElement.scrollWidth > vColElement.clientWidth
        }
        return false
      } else {
        return false
      }
    },
    redirectToRepairFileDetail(repairFileBoomerangId) {
      this.$router.push('/repair-file-detail/' + repairFileBoomerangId)
    },
    getFormattedDate(date) {
      return new Date(date).toLocaleDateString()
    }
  }
}
</script>

<style scoped>
.customer-recovery {
  min-height: 470px;
}

.v-card {
  padding: 20px !important;
}

.title {
  font-size: 18px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}

.reminder {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.customer-recovery-row {
  height: 100%;
  max-height: 80px;
  padding: 10px 20px;
  align-items: center;
  border-radius: 20px;
  background: #efefef;
  margin-bottom: 20px;
  cursor: pointer;
}

.company {
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.date {
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;
}

.status-macro {
  padding: 5px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.status-content {
  border-radius: 5px;
  border: 1px solid var(--warning-color);
  background: #fff;
}

.last-item {
  margin-bottom: 0;
}
</style>
